import type { SDKConfig, ThemeConfig } from '../types';

const DEFAULT_API_URL = 'http://localhost:8000/api';

const DEFAULT_THEME: ThemeConfig = {
  primaryColor: '#3b82f6',
  secondaryColor: '#6b7280',
  textColor: '#1f2937',
  backgroundColor: '#ffffff',
  errorColor: '#ef4444',
  successColor: '#22c55e',
  warningColor: '#eab308',
  fontFamily: 'system-ui, sans-serif',
  borderRadius: '8px',
  spacingUnit: '4px',
};

let currentConfig: SDKConfig | null = null;

export function setConfig(config: SDKConfig): SDKConfig {
  currentConfig = {
    ...config,
    apiBaseUrl: config.apiBaseUrl || DEFAULT_API_URL,
    locale: config.locale || 'en',
    currency: config.currency || 'USD',
    theme: { ...DEFAULT_THEME, ...config.theme },
    debug: config.debug || false,
  };
  return currentConfig;
}

export function getConfig(): SDKConfig {
  if (!currentConfig) {
    throw new Error('SDK not initialized. Call Puulso.init() first.');
  }
  return currentConfig;
}

export function getTheme(): ThemeConfig {
  return getConfig().theme || DEFAULT_THEME;
}

export function getLocale(): 'en' | 'es' {
  return getConfig().locale || 'en';
}

export function isInitialized(): boolean {
  return currentConfig !== null;
}

